import { DialogContent } from '@mui/material';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { OtherIndividualInfo } from '../../../../domain/person';
import { Dialog } from '../../../../general/components/dialog';
import { OtherIndividualInfoForm } from '../../components/other-individual-form';
import { saveOtherIndividual } from '../../reducers/other-individuals.reducer';

type Props = {
  onClose: () => void;
  context: {
    person: OtherIndividualInfo;
    includePhone: boolean;
    edit: boolean;
  };
};

const OtherIndividualInfoDlg: React.FC<Props> = ({ onClose, context: { person, edit, includePhone } }: Props) => {
  const dispatch = useDispatch();
  const handleSubmit = useCallback(
    (personInfo: OtherIndividualInfo) => {
      dispatch(saveOtherIndividual(personInfo));
      onClose();
    },
    [onClose, dispatch],
  );

  return (
    <Dialog title={`${edit ? 'Edit' : 'Add'} Owner or Executive`} onClose={onClose} fullWidth>
      <DialogContent>
        <OtherIndividualInfoForm person={person} edit={edit} includePhone={includePhone} onSubmit={handleSubmit} />
      </DialogContent>
    </Dialog>
  );
};

export { OtherIndividualInfoDlg };
